import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	container: {
		background: "#FAF3E4",
		padding: theme.spacing(2),
		[theme.breakpoints.up("sm")]: {
			padding: theme.spacing(3)
		}
	},
	wrapper: {
		border: `1px solid #AFA08B`,
		padding: theme.spacing(2),
		[theme.breakpoints.up("sm")]: {
			columnCount: 2,
			columnGap: theme.spacing(4.5),
			padding: theme.spacing(4.5)
		},
		[theme.breakpoints.up("md")]: {
			columnCount: 3
		},
		[theme.breakpoints.up("lg")]: {
			columnCount: 4
		}
	},
	item: {
		breakInside: "avoid",
		marginBottom: theme.spacing(3)
	},
	title: {
		color: "#AFA08B",
		fontFamily: "Cochin, serif",
		fontSize: 27,
		fontWeight: 700,
		lineHeight: 1.4,
		marginBottom: theme.spacing(1)
	},
	copyrights: {
		marginTop: theme.spacing(2)
	}
}));

export default styles;
